<template>
    <div class="container home-container">
        <card class="home-card">
            <div class="card-body card-padded">
                <p>A 30 minute appointment costs just...</p>

                <div class="mt-8">
                    <template v-if="loadingPrices">
                      <p class="title leading-none"></p>
                    </template>
                    <template v-else>
                      <p class="title leading-none">&pound;{{ priceLowest }} - &pound;{{ priceHighest }}</p>
                    </template>
                    <p class="mt-8"><em>Prices will vary depending on clinic location</em></p>
                </div>
            </div>
        </card>

        <card :dark="true" class="home-card">
            <div class="card-body card-padded">
                <img src="../../assets/images/heart-handshake.svg" alt="Logo" class="inline mb-4" />
                <p class="mb-2">Approved by all major insurers</p>
                <p><a href="tel:+443306780850">Call for more info</a></p>
            </div>
        </card>
    </div>
</template>

<script>
    import Card from './Card';
    import {Prices} from '../../lib/Prices';
    import store from "@/store";

    export default {
        name: 'welcome',

        components: {
            Card,
        },

        computed: {
            priceLowest() {
                return Prices.outsideM25();
            },

            priceHighest() {
                return Prices.hasExceptionPrice() ? Prices.exception() : Prices.insideM25();
            },
            loadingPrices() {
              return store.getters['rates/getLoadingPrices']
            },
        },
    }
</script>

<style lang="scss">
    .home-container {
        @apply mx-auto w-full;

        @screen md {
            @apply flex flex-row justify-center items-stretch;
        }
    }

    .home-card {
        @apply mx-4 my-8 text-center;

        @screen md {
            @apply w-1/2;
        }

        @screen lg {
            @apply w-1/3;
        }
    }
</style>
